module.exports = __webpack_public_path__ + "img/seguros.1464e9b4.png";